
import { eqBy, uniqBy, prop } from 'ramda';

const itemsEqual = eqBy(prop('name'));

const unionItems = uniqBy(prop('name'));

/**
 * @private
 * @param {Array.<CXPItem>}
 * @param {Array.<CXPItem>}
 * @returns {Array.<CXPItem>}
 */
const mergeItemsPair = (itemsA, itemsB) => {
  // Create new array of itemsA, but replace matching items from itemsB
  const itemsAWithOverrides = itemsA.map(itemA =>
    itemsB.find(itemsEqual(itemA)) || itemA);

  // Merge itemsA & itemsB, removing duplicates (duplicates should already be copied into itemsA)
  return unionItems(itemsAWithOverrides.concat(itemsB));
};

/**
 * Takes any number of arrays of CXP items and merges them all into a single array of CXP items.
 * @param {...Array.<CXPItem>}
 * @return Array.<CXPItem>
 */
const mergeItems = (...itemsArrays) => itemsArrays.reduce(mergeItemsPair, []);

export default mergeItems;
